// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 636 ? "a9896983" : chunkId) + "." + {"636":"7cd6c327580f0d33","803":"c303fe3a32c6c92b"}[chunkId] + ".js";
};